import { render } from "./PolitiqueDeConfidentialite.vue?vue&type=template&id=2d2f3ee4&scoped=true"
import script from "./PolitiqueDeConfidentialite.vue?vue&type=script&lang=js"
export * from "./PolitiqueDeConfidentialite.vue?vue&type=script&lang=js"

import "./PolitiqueDeConfidentialite.vue?vue&type=style&index=0&id=2d2f3ee4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2f3ee4"]])

export default __exports__